
import Vue from 'vue'
import { toCanvas } from 'qrcode'

import { ClientPageConfigPickupPoint } from '@/types'

export default Vue.extend({
  name: 'pickup-point-qr-code-viewer',
  props: {
    code: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
    endCollectionDate: {
      type: String,
      required: true,
    },
    storeName: {
      type: String,
      required: false,
    },
    config: {
      type: Object as () => ClientPageConfigPickupPoint,
      required: true,
    },
  },
  data() {
    return {
      canvas: null,
    }
  },
  computed: {
    cssGetBackgroundColor() {
      return {
        '--code-viewer-background-color': this.config.theme.backgroundColor || '#FFFFFF',
        '--code-viewer-primary-color': this.config.theme.primaryColor || '#FFFFFF',
      }
    },
    showOrderId(): boolean {
      if (this.config.infos && this.orderId) {
        return this.config.infos.showOrderId as boolean
      }
      return !!this.orderId
    },
    showEndCollectionDate(): boolean {
      if (this.config.infos && this.endCollectionDate) {
        return this.config.infos?.showEndCollectionDate as boolean
      }
      return !!this.endCollectionDate
    },

    showPinCode(): boolean {
      if (this.config.infos && this.code) {
        return this.config.infos.showPinCode as boolean
      }
      return !!this.code
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initQRCode(this.code)
    })
  },
  methods: {
    async initQRCode(code: string) {
      await toCanvas(this.$refs.canvas, code, {
        width: 170,
        margin: 0,
      })
    },
  },
})
